"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const lodash_1 = __importDefault(require("lodash"));
const constants_1 = require("@powerednow/shared/constants");
const object_1 = require("@powerednow/shared/modules/utilities/object");
const Renderer_1 = __importDefault(require("../../classes/Renderer"));
class CompanyRenderData extends Renderer_1.default {
    async getLogoData() {
        const headerLogoItems = [];
        const footerLogoItems = [];
        const previewLogoItems = [];
        let headerBottom = 0;
        let footerTop = constants_1.LAYOUT.BOUNDARY.HEIGHT;
        const logoItems = await this.item.getAllUploadedDocumentLogo();
        logoItems.forEach(logoItem => {
            const dataItem = (0, object_1.pickProperties)(logoItem.data.getPureDataValues(), ['id', 'url', 'width', 'height', 'top', 'left', 'isCompanyLogo', 'type']);
            //
            // Scale image if needed
            //
            if (dataItem.height >= constants_1.LAYOUT.BOUNDARY.HEIGHT / 2) {
                dataItem.width = (dataItem.width / dataItem.height) * (constants_1.LAYOUT.BOUNDARY.HEIGHT / 3);
                dataItem.height = constants_1.LAYOUT.BOUNDARY.HEIGHT / 3;
            }
            if (dataItem.width >= constants_1.LAYOUT.BOUNDARY.WIDTH) {
                dataItem.width = constants_1.LAYOUT.BOUNDARY.WIDTH;
                dataItem.height = (dataItem.height / dataItem.width) * (constants_1.LAYOUT.BOUNDARY.WIDTH);
            }
            //
            // Calculate effect on header and footer
            //
            const logoBottom = dataItem.top + dataItem.height;
            dataItem.companyLogoImageStyle = `background-image:url('${dataItem.url}');width:${dataItem.width}px !important; height: ${dataItem.height}px !important; max-width: inherit !important; max-height: inherit !important;`;
            if (logoBottom < constants_1.LAYOUT.BOUNDARY.HEIGHT / 2) {
                //
                // Upper part
                //
                if (logoBottom > headerBottom) {
                    headerBottom = logoBottom;
                }
                dataItem.companyLogoContainerStyle = `left:${dataItem.left}px !important; top: ${dataItem.top}px !important; z-index: 9999;`;
                previewLogoItems.push(dataItem);
                headerLogoItems.push(dataItem);
            }
            else {
                //
                // Bottom part
                //
                if (dataItem.top < footerTop) {
                    footerTop = dataItem.top;
                }
                previewLogoItems.push({
                    companyLogoContainerStyle: `left:${dataItem.left}px !important; top: ${dataItem.top}px !important; z-index: 9999;`,
                    ...dataItem,
                });
                const bottom = constants_1.LAYOUT.BOUNDARY.HEIGHT - dataItem.top - dataItem.height;
                footerLogoItems.push({
                    companyLogoContainerStyle: `left:${dataItem.left}px !important; top: auto; bottom:${bottom}px !important; z-index: 9999;`,
                    ...dataItem,
                });
            }
        });
        return {
            headerLogos: headerLogoItems,
            footerLogos: footerLogoItems,
            previewLogos: previewLogoItems,
            previewOnlyPageSize: `height: ${constants_1.LAYOUT.BOUNDARY.HEIGHT}px !important; width: ${constants_1.LAYOUT.BOUNDARY.WIDTH}px !important;`,
            headerHeight: `${headerBottom}px !important;`,
            footerStyle: `width: 100%; min-height:${constants_1.LAYOUT.BOUNDARY.HEIGHT - footerTop}px !important;`,
        };
    }
    async getDocumentTemplateData() {
        const registeredAddress = await this.item.getCompanyAddress();
        const invoiceAddress = await this.item.getInvoiceAddress();
        const registeredCountry = await registeredAddress.getCountry();
        const addressPart1 = lodash_1.default.compact([registeredAddress.data.address2]);
        const addressPart2 = lodash_1.default.compact([registeredAddress.data.address1, registeredAddress.data.city, registeredAddress.data.state, registeredAddress.data.postcode]);
        const addressPart3 = lodash_1.default.compact([registeredCountry?.data.name]);
        const registeredAddressParts = lodash_1.default.flattenDeep([addressPart1, addressPart2, addressPart3]);
        const address = invoiceAddress || registeredAddress;
        const country = await address.getCountry();
        const themeVars = await this.item.getThemeInlineCssVariables();
        return {
            company: {
                utr: this.item.data.utr,
                company_number: this.item.data.company_number,
                address1: address.data.address1,
                address2: address.data.address2,
                registeredAddress: registeredAddressParts.join(', '),
                city: address.data.city,
                state: address.data.state,
                postcode: address.data.postcode,
                countryName: country?.data.name,
                vat_id: this.item.data.vat_id,
                displayCompanyAddress: Boolean(this.item.data.displayCompanyAddress),
                name: this.item.data.name,
                phone: this.item.data.phone,
                displayPhonenumber: this.item.data.displayPhonenumber,
                companySettings: {
                    show_country: Boolean(this.item.data.companySettings?.show_country),
                },
            },
            quantityCanBeSupressed: this.item.data.autoSupressQuantity,
            templateVariables: `:root { ${themeVars} }`,
            ...await this.getLogoData(),
        };
    }
}
exports.default = CompanyRenderData;
//# sourceMappingURL=../../../../src/models/company/renderData.js.map